import { render } from "./GroupCard.vue?vue&type=template&id=bf050ea4&scoped=true"
import script from "./GroupCard.vue?vue&type=script&lang=js"
export * from "./GroupCard.vue?vue&type=script&lang=js"

import "./GroupCard.vue?vue&type=style&index=0&id=bf050ea4&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf050ea4"]])

export default __exports__